"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthReport = exports.HealthComponent = exports.HealthStatus = void 0;
const zod_1 = require("zod");
exports.HealthStatus = zod_1.z.enum(['ok', 'degraded', 'down']);
exports.HealthComponent = zod_1.z.object({
    name: zod_1.z.string().min(1),
    status: exports.HealthStatus,
    latencyMs: zod_1.z.number().int().nonnegative().optional(),
    message: zod_1.z.string().optional(),
});
exports.HealthReport = zod_1.z.object({
    status: exports.HealthStatus,
    timestamp: zod_1.z.string().datetime(),
    version: zod_1.z.string(),
    components: zod_1.z.array(exports.HealthComponent),
});
//# sourceMappingURL=health.js.map